import PropTypes from "prop-types";
import { codeDisplay } from "../../utils/PTO/helpers";
import { Aligned } from "./Aligned";
import { PTOBar } from "./PTOBar";
import { Caption, Margined } from "./styles";
import { getCodesAlphabetically } from "./utils";

export const BalanceDisplay = ({
  usablePTO = {},
  pendingPTO = {},
  scheduledPTO = {},
  completedPTO = {},
  editingPTO = {},
  isHorizontalComponent = false,
}) => {
  const codes = getCodesAlphabetically(usablePTO);
  return (
    <Aligned isHorizontalComponent={isHorizontalComponent}>
      {codes.map((code) => (
        <Margined key={code}>
          <h3 className="mb-16">{codeDisplay(code)}</h3>
          <PTOBar
            usablePTO={usablePTO[code]}
            editingPTO={editingPTO[code] || 0}
            pendingPTO={pendingPTO[code] || 0}
            scheduledPTO={scheduledPTO[code] || 0}
            completedPTO={completedPTO[code] || 0}
          />
          {usablePTO[code] > 0 ? (
            <Caption>
              {parseFloat(usablePTO[code]).toFixed(2)} hours available
            </Caption>
          ) : (
            <Caption>Not enough hours available</Caption>
          )}
        </Margined>
      ))}
    </Aligned>
  );
};

BalanceDisplay.propTypes = {
  isHorizontalComponent: PropTypes.bool,
  usablePTO: PropTypes.shape({}),
  pendingPTO: PropTypes.shape({}),
  scheduledPTO: PropTypes.shape({}),
  completedPTO: PropTypes.shape({
    sick: PropTypes.number,
  }),
  editingPTO: PropTypes.shape({}),
};
